module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-top-main-title-right-5c33f1e72c1dc7bbf700c5d1ed49520e.svg";